import React, { useEffect, useState } from 'react';
import './HowToEarnPage.scss';
import { webUrl } from '../../utils/config';
import { useLocation, useNavigate } from 'react-router-dom';
import { gql, useMutation, useQuery } from '@apollo/client';
import { useDispatch } from 'react-redux';
import { authenticate } from '../../store/reducer/auth';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Colors from '../../constants/Colors';
import ReviewListItem from '../../components/ListItem/ReviewListItem';
import { URLConfig } from '../../utils/config';

const GET_ALL_TESTIMONIALS = gql`
  query GetAllTestimonialsByPage($input: GetTestimonialsByPageInput!) {
    getAllTestimonialsByPage(input: $input) {
      _id
      message
      isVisible
      rating
      createdAt
      added_by {
        name
        total_earnings
      }
    }
  }
`;

const GET_TARGET_DETAILS = gql`
  query GetTargetDetailsById($input: MongoIdInput!) {
    getTargetDetailsById(input: $input) {
      _id
      message
      timeSpent
      referred_by {
        _id
      }
      target_name
      target_phone
    }
  }
`;

const UPDATE_TARGET = gql`
  mutation UpdateAndSendContentToTarget($input: UpdateTargetInput!) {
    updateAndSendContentToTarget(input: $input) {
      _id
      target_name
      target_phone
    }
  }
`;

const HowToEarnPage: React.FC<{}> = (props) => {
  const [updateTarget, updateTargetData] = useMutation(UPDATE_TARGET);
  const [timeSpent, setTimeSpent] = useState(0);
  const [page_number, setPage_number] = useState(1);
  const navigate = useNavigate();

  const { search } = useLocation();
  const [targetID, setTargetID] = useState('');
  const dispatch = useDispatch();

  useEffect(() => {
    const tID = search.split('=')[1];
    setTargetID(tID);
  }, [search.split('=')[1]]);

  const {
    data: testimonials_data,
    error: testimonials_dataError,
    loading: testimonials_dataLoading,
    refetch: testimonials_dataRefectch,
  } = useQuery(GET_ALL_TESTIMONIALS, {
    variables: {
      input: {
        page: page_number,
        item_per_page: 3,
      },
    },
  });

  const {
    data: target_data,
    error: target_dataError,
    loading: target_dataLoading,
    refetch: target_dataRefectch,
  } = useQuery(GET_TARGET_DETAILS, {
    variables: {
      input: {
        _id: search.split('=')[1] || targetID || '65c9411ae64e6232bbe4d140',
      },
    },
    fetchPolicy: 'network-only',
  });

  const target = target_data?.getTargetDetailsById;
  const reviews = testimonials_data?.getAllTestimonialsByPage || [];

  useEffect(() => {
    if (target) {
      dispatch(
        authenticate({
          isAuthenticated: true,
          target: {
            _id: target._id,
            target_name: target.target_name,
            target_phone: target.target_phone,
            referred_by: target.referred_by?._id,
          },
        })
      );
    }
  }, [target?._id]);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeSpent((prev) => prev + 5);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const updateData = async () => {
      try {
        // Check if target is valid
        if (target) {
          // Update target object in the database
          await updateTarget({
            variables: {
              input: {
                _id: target._id,
                targetVisited: true,
                timeSpent: (target.timeSpent || 0) + 5,
              },
            },
          });

          // Refetch data after updating target
          await target_dataRefectch();
        }
      } catch (err) {
        console.error(err);
      }
    };

    updateData();
  }, [timeSpent]);

  return (
    <>
      <h2>আপনি আর মাত্র এক ধাপ পিছিয়ে</h2>
      <p>
        আমাদের দুইটি এপ আছে EBM Global এবং Earn By Mobile (EBM)। EBM Global এপে
        সবাই কাজ করতে পারবে, আর Earn By Mobile (EBM) এপে শুধু মেয়েরা কাজ করতে
        পারবে। নিচে দুইটি এপ সম্পর্কে বিস্তারিত আলোচনা করা হলো।
      </p>

      <br />

      <h3>1. EBM Global এপে কিভাবে কাজ করবেন? </h3>

      <p>
        EBM Global আর্নিং প্লাটফর্মে আপনাকে স্বাগতম। এই প্লাটফর্ম আপনাদের কে এনে
        দিয়েছে একটি দারুণ সুযোগ। এখানে আপনি প্রতি মাসেই খুব সহজেই ইনকাম করতে
        পারবেন ৪/৫ হাজার টাকা। EBM Global একটি মোবাইল এপ, যেটি শুধুমাত্র
        এন্ড্রয়েড ফোনে চলবে। আইফোনের জন্য এই এপ কাজ করবেনা। আপনার যদি একটি
        আন্ড্রয়েড ফোন থাকে তবে আপনি শুরু করতে পারেন আমাদের সাথে কাজ।
      </p>
      <br />
      <p>
        এখানে কাজ করার জন্য আপনাকে কিছুই করতে হবেনা আপনি শুধু গেম খেলবেন যখন
        ফ্রি থাকবেন, অথবা আপনি কিছু ১৮+ ভিডিও দেখবেন যেঁটা আমাদের প্লাটফর্মেই
        আছে, অথবা ১৮+ গল্প পড়বেন আমাদের প্লাটফর্মের মধ্যেই। যেখানে বিজ্ঞাপন
        দেখানো হবে এতটুকুই। আর এই এপেই আপনি কয়েন মাইনিং করতে পারবেন eCoin, যে
        কয়েন দিয়ে পরে টাকায় রুপান্তর করতে পারবেন। এই প্লাটফর্মে কাজ করে আপনাকে
        কোনো টাকা ডিপোজিট করতে হবেনা। আপনি যদি সাইন আপ করার সময় Refer টোকেন
        ব্যাবহার করেন (রিফার টোকেন যদি কোনো ব্যাবহারকারী থেকে এপের কথা জানতে
        পারেন বা যার থেকে এপের কথা শুনেছেন সেখান থেকে পাবেন) । তবে আপনি পাবেন
        ইন্সট্যান্ট ৫০০ টাকা বোনাস। এর পর সাইন আপ করে আমাদের এপ কাজ করার জন্য
        সেটাপ করলে এবং মাইনিং এর জন্য সেটিং সেটাপ করলে আরো পাবেন ৫০০ টাকা।
      </p>

      <br />

      <p>
        এই দুইটা স্টেপ ফলো করলে কোনো কিছু না করেই আপনি আপনার প্রথম ১০০ টাকা
        ক্যাশ আউট করতে পারবেন আপনার বিকাশ নাম্বারে। এছাড়া আপনি যদি সাইন আপ করে
        প্রমান এর জন্য ৫০০ টাকা ক্যাশ আউট করতে চান তবে সাপোর্টে কথা বলেই আপনি
        বিকাশ নাম্বারে পেয়ে যাবেন ৫০০ টাকা। আমরা কোনো প্রতারনা বা মানুষ ঠকানো
        কাজ করিনা তাই আপনি এখানে হাজার হাজার টাকা ইনকাম করে কোটিপতি হতে পারবেন
        আমরা সেই ভরষা দিবোনা, আপনি এখানে প্রতি মাসে কম পক্ষে ২/৩ হাজার টাকা
        ইনকাম করতে পারবেন। আপনার কাজের পাশে সামান্য কিছু করে যদি এই ৪/৫ হাজার
        ইনকাম করতে চান তবে আপনি আমাদের সাথে যুক্ত হতে পারেন। আপনি যদি আগ্রহী হন
        তবে আমরা আপনাকে আমাদের এপ প্রদান করবো আপনি এপ ইন্সটল করে কাজ করতে
        পারবেন। আমাদের এপ প্লে স্টোরে পাবেন না কারন এধরনের ইনকাম এপ গুলো স্টোরে
        দেওয়া যায়না। এজন্য মোবাইল কে বিশেষ ফাকি দিয়ে এই ধরনের কাজ করতে হয় নয়ত
        আমাদের একাউন্ট গুলো ব্লক হয়ে যায়। আমরা আপনাকে ওয়াটসেপে আমাদের এপ সেন্ড
        করার পর, আপনি সেটি ডাউনলোড করে ইন্সটল করতে পারবেন। তার আগে আপনাকে যে কাজ
        করতে হবে সেটি এখানে বলে দেওয়া হবে।
      </p>

      <ul>
        <br />
        <li>
          আপনি যখনি আমাদের দেওয়া এপ ডাউনলোড করে ইন্সটল করতে যাবেন তখনি এরকম
          দেখাবে, এটা সব মোবাইলেই দেখায়, প্লে স্টোরের বাইরে থেকে এপ ইন্সটল করতে
          গেলে সেই সোর্স থেকে ইন্সটল জন্য পারমিশন দেওয়া লাগে। আগে যদি এভাবে এপ
          ইন্সটল করে থাকেন ওয়াটস এপের মাধ্যমে তাহলে এটা আর দেখাবেনা। যদি দেখায়
          তবে সেটিং এ চাপ দিয়ে মার্ক করা সুইচ অন করে দিবেন। এর পর আবার ইন্সটল
          করবেন তাহলে আর এটা দেখাবেনা।
          <br />
          <img style={{}} src='/images/unknownsource_1.jpg' alt='Unknown s1' />
          <img style={{}} src='/images/unknownsource_2.jpg' alt='Unknown s2' />
        </li>
        <br />
        <li>
          এরপর যদি এপ ইন্সটল করতে যান তবে আপনাকে এরকম প্লে স্টোর ব্লক দেখাবে।
          কারন এখন ফোন গুলোতে প্লে স্টোরের বাইরে থেকে এপ ইন্সটল করতে গেলেই এরকম
          দেখায়, তাই প্লে প্রটেক্ট অপশন অফ করা লাগবে। নিচে কিভাবে অফ করতে হবে
          সেটা দেওয়া আছে।
          <br />
          <img style={{}} src='/images/play_block.jpg' alt='Play Block' />
        </li>

        <br />

        <li>
          প্লে ব্লক অফ করার জন্য আপনাকে নিচের প্রসেস ফলো করতে হবে। প্রথমে আপনি
          গুগল প্লে স্টোরে ঢুকবেন, যেখান থেকে এপ ডাউনলোড করে, এর পর ডান পাশে
          উপরের কোনায় প্রফাইল গোল ছবিতে চাপ দিয়ে এর পর মার্ক করা Play Protect এর
          উপর চাপ দিবেন। এর পর ডান পাশের উপরের কোনায় সেটিং আসলে সেখানে চাপ
          দিবেন। তাহলে অফ করার অপশন আসবে।
          <br />
          <img style={{}} src='/images/play_block_s1.jpg' alt='Play Block S1' />
          <img style={{}} src='/images/play_block_s2.jpg' alt='Play Block S2' />
          <img style={{}} src='/images/play_block_s3.jpg' alt='Play Block S3' />
        </li>

        <li>
          এর পর প্রথম সুইচে চাপ দিলে Turn off আসবে সেখানে চাপ দিলে অফ হয়ে যাবে
          এর পর এপ ইন্সটল করতে পারবেন।
          <br />
          <img style={{}} src='/images/play_block_s4.jpg' alt='Play Block S4' />
          <img style={{}} src='/images/play_block_s5.jpg' alt='Play Block S5' />
        </li>

        <li>
          এপ টি ইন্সটল হয়ে গেলে আপনি সাইন আপ করবেন, সাইন আপ করার টাইমে আপনি এই
          কোড টি ব্যাবহার করলে ৫০০ টি পয়েন্টস পাবেন, প্রতিটি পয়েন্টস এর মূল্য এক
          টাকা করে মানে ৫০০ টাকা পাবেন। পয়েন্টস পেতে নিচের কুপন কোড টি কপি করে
          বসিয়ে দিন, কুপোন কোডের ঘরে। সবার কুপন কোড আলাদা। আপনি অন্য কারো কুপন
          কোড ব্যাবহার করতে পারবেন না। আপনি আপনাকে পাঠানো কুপোন কোডই ব্যাবহার
          করবেন এনং সেটি কাউকে শেয়ার করবেন না।
          <p style={{ marginBottom: 10 }}>
            আপনার কুপোন কোডঃ <strong>{targetID}</strong>
          </p>
          {target && (
            <CopyToClipboard
              text={targetID}
              onCopy={() => {
                alert('কুপোন কোড কপি হয়েছে');
              }}>
              <span
                style={{
                  color: Colors.primaryColorLight,
                  cursor: 'pointer',
                }}>
                কুপোন কোড কপি করতে এখানে ক্লিক করুন
              </span>
            </CopyToClipboard>
          )}
          <p style={{ marginTop: 10 }}>
            যদি কুপোন কোড না দেখতে পান তাহলে কুপোন অফার টি আপনার জন্য প্রযজ্য না
          </p>
        </li>
      </ul>

      <br />

      <p>
        এপ ইন্সটল এর পর আপনাকে বাকি প্রসেস ওয়াটসেপে বুঝিয়ে দেওয়া হবে। প্রথমে ৫০০
        পয়েন্ট পাবেন এর পর এপ সেটিংস সেটাপ করে নিলে বাকি ৫০০ পয়েন্ট পাবেন। এর পর
        মোট ১০০০ পয়েন্ট মানে ১০০০ টাকা ক্যাশ আউট দিতে পারবেন। যদি ভালো লাগে এর
        পর থেকে কাজ করতে পারবেন, গেম খেলা ভিডিও দেখা গল্প পড়া , মাইনিং করা এগুলা
        করেই আপনি প্রতি মাসে টাকা ইনকাম করতে পারবেন। ৫০০ হলেই ক্যাশ আউট দিতে
        পারবেন।
      </p>

      <br />
      <hr />
      <br />

      <div className='how_to_earn_img'>
        <div className='how_to_earn_img_left'>
          <h3>2. Earn By Mobile এপে কিভাবে কাজ করবেন?</h3>

          <p>
            Earn By Mobile (EBM) সম্পর্কে জানতে এপের লার্নিং পেজ দেখুন এবং
            ওয়াটসেপে যোগাযোগ করুন। এপ ইন্সটল করতে উপরের প্রসেস ফলো করুন।
          </p>

          <br />
        </div>
      </div>

      <br />

      <h3>এটি কিভাবে কাজ করে? </h3>
      <p>
        এই প্লাটফর্ম সম্পূর্ন এন্ড্রয়েড এপ এর উপর ভিত্তি করে চলে। এবং আপনাকে
        এপটি ডাউনলোড করে সেখানে কাজ শিখুন মেনু থেকে কাজ গুলো শিখে নিয়ে এর পর কাজ
        করতে হবে।
      </p>

      <ul>
        <br />
        <li>আপনাকে প্রথমে এই পেজ ভালো করে পড়ে বুঝে নিতে হবে।</li>
        <li>এর পর এই পেজের শেষে দেওয়া লিংক থেকে মোবাইল এপ টি ডাউনলোড করবেন।</li>
        <li>
          এই এপটি গুগল প্লেস্টোরে পাবেন না, কারন এধরনের কাজ গুগল এলাউ করেনা, তাই
          এটা আপনার এবং প্লাটফর্ম পরিচালনা কমিটির সবার জন্য সুবিধা যে আপনি গুগল
          ড্রাইভ বা পেজের নিচে দেওয়া লিংক থেকে এই এপটি ডাউনলোড করে আপনার ফোনে
          ইন্সটল করুন। লিংক এ ক্লিক দিলেই ডাউনলোড শুরু হবে। কিভাবে ইন্সটল করবেন
          তার গাউড নিচে দেওয়া হয়েছে।
        </li>
        <li>
          এর পর মোবাইল এপ ওপেন করে কাজ শিখুন মেনু থেকে কাজ শিখে তার পর কাজ করুন
          এবং প্রফাইল সম্পূর্ন করে টাকা নিন। আপনাকে অবশ্যই কাজ শিখুন পেজ থেকে
          সম্পূর্ন কাজ শিখে নিতে হবে, আপনি এখানে থাকা অনেক ধরনের কাজের মধ্যে
          যেকোনো ধরনের কাজ অথবা কয়েকটি কাজ করতে পারেন। একটু ভালো করে পড়ে
          সিদ্ধান্ত নিলে আসা করি বুঝতে পারবেন।
        </li>
      </ul>

      <br />

      <h3>আমরা আপনার নাম্বার/ইমেইল কিভাবে পেয়েছি?</h3>
      <p>
        যদি আপনি মেসেজ পেয়ে থাকেন, ইমেইল পেয়ে থাকেন অথবা ওয়াটসএপের মাধ্যমে
        আমাদের খোজ পেয়ে থাকেন তাহলে এই প্যারার লেখাটুকু আপনার জন্য। আপনারা
        হামেশাই বিভিন্ন প্রয়োজনে বিভিন্ন প্রতিষ্ঠান এ আপনাদের নাম্বার গুলো দিয়ে
        থাকেন, অথবা কোনো জাইগাতে চাকরির জন্য আবেদনে দিয়ে থাকেন। প্রতিটা দেশে
        এরকম অনেক প্রতিষ্ঠান আছে যাদের কাছে এই ধরনের সোর্চ থেকে অনেক
        নাম্বার/ইমেইল এক জায়গায় করে রাখে এবং পরে সেটি আমাদের মত প্রতিষ্ঠান কে
        দেয়, এই প্রতিষ্ঠান গুলো যারা নাম্বার গুলো বিক্রি করে অথবা যারা কেনে
        তাদের কোনো এসে জায় না আপনি কে আপনি কোথায় থাকেন কি করেন। এদের শুধু
        নাম্বার/ইমেইল ই দরকার হয় এর পর এই নাম্বারে বিভিন্ন মেসেজ পাঠানো হয়, যেমন
        আমরা পাঠিয়েছি। আমরা জানি না আপনি কে, কোথায় থাকেন, আমাদের একমাত্র প্রয়োজন
        যদি আমাদের প্লাটফর্ম আপনার ভালো লেগে থাকে তাহলে আপনি এটা ব্যাবহার করবেন।
        আমরা আপনার নম্বর টি এভাবে পেয়েছি এবং এটা মোটেই চিন্তার কিছু নয়, কারন হয়ত
        আপনি নিজেই দেখেছেন আপনি হয়ত অনেক অফিশিয়াল মেসেজ, বিজ্ঞাপনের মেসেজ পেয়ে
        থাকেন, এটা ঠিক এভাবেই।
      </p>

      <br />

      <h3>কিভাবে শুরু করবেন?</h3>

      <p>
        আপনাকে কাজ করতে হলে অবশ্যই সব কিছু আগে ভালো ভাবে পড়ে নিতে হবে, আমি আবারো
        বলছি এই প্লাটফর্মে কাজ করতে হলে প্রতিটি পেজের লেখা গুলো খুব মনোযোগ দিয়ে
        পড়তে হবে, শুরু থেকে শেষ পর্যন্ত। আপনার এখন সময় না থাকলে পরে আসুন, কিন্তু
        এপ ডাউনলোড করার আগে আপনাকে অবশ্যই এই পেজ ভালো করে পড়ে নিতে হবে। এবং এপ
        ডাউনলোড করার আগে সর্ব প্রথম সাইন আপ করে কাজ শিখুন মেনু থেকে অবশ্যই কাজ
        শিখে নিতে হবে।
      </p>

      <br />

      <p>
        আমাদের প্লাটফর্ম এর সাথে যুক্ত হউন এবং নিজের জীবন কে বদলে ফেলুন,
        নিশ্চিন্তে নিরাপদে ঘরে বসেই উপার্জন করুন।
      </p>

      <br />

      <p>
        আপনার কোনো ধরনের প্রশ্ন থাকলে নিচে দেওয়া ইমেইলে, অথবা ওয়াটসএপ নাম্বারে
        যোগাযোগ করুন, অথবা এপের মধ্যেই মেসেজের ব্যবস্থা আছে সেখানে আমাদের টিম
        থেকে সাহায্য নিতে পারেন। নিচের লিংক থেকে ডাউনলোড করুন এপ।
      </p>

      <br />

      <img
        className='play_icon'
        onClick={() => {
          window.open(URLConfig.appDownloadUrl, '_blank');
        }}
        style={{
          cursor: 'pointer',
        }}
        src='/images/googleplay.png'
        alt='Bus'
      />

      <br />
      <br />

      <br />
      <p>শুভকামনায়,</p>
      <p>Earn By Mobile (EBM) Team</p>

      <div className='home_testimonial_section'>
        <h2>আমাদের ব্যাবহার কারীদের রিভিউ</h2>
        {/* WILL CHAGE TO CUSTOMER REVIEW TO COMPANY */}
        <div className='home_testimonial_section_items'>
          {reviews &&
            reviews?.map((rv: any) => {
              return (
                <ReviewListItem
                  _id={rv._id}
                  key={rv._id}
                  createdAt={rv.createdAt}
                  rating={rv.rating}
                  message={rv.message}
                  review_by={{
                    name: rv.added_by.name,
                    total_earnings: rv.added_by.total_earnings,
                  }}
                />
              );
            })}
        </div>
        <div className='home_testimonial_section_action'>
          <input
            type='submit'
            value='আরো দেখুন'
            onClick={() => {
              navigate('/reviews');
            }}
          />
        </div>
      </div>
    </>
  );
};

export default HowToEarnPage;
